
(function nonBubblingClickDirectiveDefinition() {

    angular.module('NonBubblingClick')
            .directive('nonBubblingClick', ['$parse', function nonBubblingClickDirective($parse) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {

                        if (attrs.nonBubblingClick) {
                            var action = $parse(attrs.nonBubblingClick);

                            element.on('click', function (evt) {
                                evt.stopPropagation();
                                evt.preventDefault();
                                scope.$apply(function () {
                                    action(scope);
                                });
                            });
                        } else {
                            element.on('click', function (evt) {
                                evt.stopPropagation();
                                evt.preventDefault();
                            });
                        }

                    }
                };
            }]);

})();
